import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const bookServiceApi = createApi({
  reducerPath: 'bookServiceApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['bookService'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getBookServiceList: builder.query({
      query: () => ({
        method: 'GET',
        path: `Services`,
      }),
      providesTags: ['bookService'],
    }),
    getServiceTree: builder.query({
      query: () => ({
        method: 'GET',
        path: `Services/GetServiceTree`,
      }),
      transformResponse: (response) => {
        if (response?.data) {
          return {
            ...response,
            data: response.data.map((group) => ({
              ...group,
              services: group.services ? [...group.services].sort((a, b) => {
                const indexA = a.index ?? Number.MAX_SAFE_INTEGER;
                const indexB = b.index ?? Number.MAX_SAFE_INTEGER;
                return indexA - indexB;
              }) : []
            }))
          };
        }
        return response;
      },
      providesTags: ['bookService'],
    }),
    createBookService: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Services',
      }),
      invalidatesTags: ['bookService'],
    }),
    UpdateBookService: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: `Services/`,
      }),
      invalidatesTags: ['bookService'],
    }),
    DeleteBookService: builder.mutation({
      query: ({ data, id }) => ({
        data,
        method: 'DELETE',
        path: `Services/${id}`,
      }),
      invalidatesTags: ['bookService'],
    }),
    changeServiceIndex: builder.mutation({
      query: ({ sourceId, oldIndex, newIndex }) => ({
        method: 'PATCH',
        path: `Services/ChangeIndex?sourceId=${sourceId}&oldindex=${oldIndex}&newindex=${newIndex}`,
      }),
      invalidatesTags: ['bookService'],
    }),
    AddServiceMenu: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Services/AddServiceMenu',
      }),
      invalidatesTags: ['bookService'],
    }),
    RemoveServiceMenu: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Services/RemoveServiceMenu/${id}`,
      }),
      invalidatesTags: ['bookService'],
    }),
    UpdateServiceMenu: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: 'Services/UpdateServiceMenu',
      }),
      invalidatesTags: ['bookService'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const bookServiceApiReducerName = bookServiceApi.reducerPath;
export const bookServiceApiReducer = bookServiceApi.reducer;
export const bookServiceApiMiddleware = bookServiceApi.middleware;

export const {
  useGetBookServiceListQuery,
  useGetServiceTreeQuery,
  useCreateBookServiceMutation,
  useUpdateBookServiceMutation,
  useDeleteBookServiceMutation,
  useChangeServiceIndexMutation,
  useAddServiceMenuMutation,
  useRemoveServiceMenuMutation,
  useUpdateServiceMenuMutation,
} = bookServiceApi;
